import { DynamicIcon, SidePanelCard } from 'src/components';
import { Conversation } from 'src/graphql';
import { ConversationDetails } from './ConversationDetails/conversation-details';

interface ConversationCardProps {
  conversation: Conversation;
  /** The panel is still hydrating the associated address. */
  loading?: boolean;
}

export const ConversationCard = ({ conversation, loading }: ConversationCardProps) => (
  <SidePanelCard
    data-testid="conversation-details-card"
    defaultOpen
    leading={
      <DynamicIcon
        name="messages-square"
        library="lucide"
        sx={(theme) => ({
          flexShrink: 0,
          width: '1.25rem',
          height: '1.25rem',
          fontSize: '1.25rem',
          color: theme.palette.custom.OV.entity.conversation,
        })}
      />
    }
    title={conversation.subject}
    titleTooltip={conversation.subject ?? undefined}
  >
    <ConversationDetails conversation={conversation} loading={loading} />
  </SidePanelCard>
);
